import gql from 'graphql-tag';

const deleteMarketFactorMutation = gql`
  mutation deleteMarketFactor($input: DestroyMarketFactorInput!) {
    deleteMarketFactor(input: $input) {
      success
      errors
    }
  }
`;

export default deleteMarketFactorMutation;
